var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import MasterDataService from "@/common/services/masterdataService";
import { convertToLanguage } from "@/common/utils/languageUtilities";
import EntityService from "@/common/services/EntityService";
import ValidationUtilities from "../../../../common/utils/validationUtilities";
var state = {
    shutdown: false,
    appId: null,
    currentUser: {},
    language: "fi",
    updating: false,
    saving: false,
    savingInstances: 0,
    saved: false,
    saveFailed: false,
    loading: false,
    downloadingPdf: false,
    downloadingFile: false,
    lock: false,
    dirty: false,
    modified: false,
    section: 0,
    period: 0,
    month: 0,
    locking: false,
    sectionLockStatus: {
        recordId: '',
        sectionNumber: 0,
        isLocked: false,
        isLockedForUser: false,
        isPastDeadline: false,
        isLockedState: false
    },
    recordId: "",
    recordable: null,
    reset: false,
    activeMenuTab: null,
    validationErrors: [],
    configuration: null,
    apiFlags: {
        lockChecked: false,
        dataRetrieved: false,
        validationDone: false
    },
    municipalities: { fi: [], sv: [] },
    regions: { fi: [], sv: [] },
    wellbeingServiceCounties: { fi: [], sv: [] },
    congregations: { fi: [], sv: [] },
    organisations: [],
    applicationTypes: [],
    correspondencesCount: 0,
    showExtensionApply: false,
    preventSending: false,
    preventSendingMessage: null,
    customReadOnly: false,
    currentModel: {},
    users: [],
    cookiePolicy: null,
    isConsented: false
};
var getters = {
    appId: function (state) {
        return state.appId;
    },
    currentUser: function (state) {
        return state.currentUser;
    },
    hasProcuration: function (state) {
        var user = state.currentUser;
        if (user) {
            return user.hasProcuration;
        }
        return false;
    },
    language: function (state) {
        return state.language;
    },
    updating: function (state) {
        return state.updating;
    },
    saving: function (state) {
        return state.saving;
    },
    savingInstances: function (state) {
        return state.savingInstances;
    },
    saved: function (state) {
        return state.saved;
    },
    saveFailed: function (state) {
        return state.saveFailed;
    },
    loading: function (state) {
        return state.loading;
    },
    downloadingPdf: function (state) {
        return state.downloadingPdf;
    },
    downloadingFile: function (state) {
        return state.downloadingFile;
    },
    section: function (state) {
        return state.section;
    },
    period: function (state) {
        return state.period;
    },
    month: function (state) {
        return state.month;
    },
    sectionLockStatus: function (state) {
        return state.sectionLockStatus;
    },
    recordId: function (state) {
        return state.recordId;
    },
    recordable: function (state) {
        return state.recordable;
    },
    record: function (state) {
        return state.recordable.record;
    },
    reset: function (state) {
        return state.reset;
    },
    acticeMenuTab: function (state) {
        return state.activeMenuTab;
    },
    validationErrors: function (state) {
        return state.validationErrors;
    },
    sectionValidationErrors: function (state) {
        return function (section) { return state.validationErrors.filter(function (error) { return error.groupId == section; }); };
    },
    periodValidationErrors: function (state) {
        return function (period) { return state.validationErrors.filter(function (error) { return error.periodId == period; }); };
    },
    sectionPeriodValidationErrors: function (state) {
        return function (section, period) { return state.validationErrors.filter(function (error) { return error.groupId == section && error.periodId == period; }); };
    },
    configuration: function (state) {
        return state.configuration;
    },
    getMunicipalities: function (state) {
        return function (lang) {
            return state.municipalities[lang];
        };
    },
    getRegions: function (state) {
        return function (lang) {
            return state.regions[lang];
        };
    },
    getWellbeingServiceCounties: function (state) {
        return function (lang) {
            return state.wellbeingServiceCounties[lang];
        };
    },
    congregations: function (state) {
        return function (lang) {
            return state.congregations[lang];
        };
    },
    organisations: function (state) {
        return state.organisations;
    },
    applicationTypes: function (state) {
        return state.applicationTypes;
    },
    showExtensionApply: function (state) {
        return state.showExtensionApply;
    },
    preventSending: function (state) {
        return state.preventSending;
    },
    preventSendingMessage: function (state) {
        return state.preventSendingMessage;
    },
    flag: function (state) {
        return function (flag) { return state.apiFlags[flag]; };
    },
    /**
     * Indicates whether the current section is ready to be rendered
     */
    sectionRenderReady: function (state) {
        var status = state.sectionLockStatus;
        var ignoreValidation = status.isLockedState
            || status.isPastDeadline
            || (status.isLocked
                && !status.isLockedForUser
                && !status.isLockedForApp
                && !status.isPastDeadline
                && !status.isLockedState);
        return state.apiFlags.dataRetrieved
            && state.apiFlags.lockChecked
            && (ignoreValidation || state.apiFlags.validationDone);
    },
    attachmentSettings: function (state) {
        return state.configuration.attachmentSettings;
    },
    customReadOnly: function (state) {
        return state.customReadOnly;
    },
    currentModel: function (state) {
        return state.currentModel;
    },
    users: function (state) {
        return state.users;
    },
    cookiePolicy: function (state) {
        return state.cookiePolicy;
    },
    consented: function (state) {
        return state.isConsented;
    }
};
var mutations = {
    START_SHUTDOWN: function (state) {
        state.shutdown = true;
    },
    SET_APPID: function (state, value) {
        state.appId = value;
    },
    SET_CURRENTUSER: function (state, value) {
        state.currentUser = value;
    },
    SET_LANGUAGE: function (state, value) {
        state.language = value;
    },
    SET_UPDATING: function (state, value) {
        state.updating = value;
    },
    SET_SAVING: function (state, value) {
        state.saving = value;
    },
    INC_SAVINGINSTANCES: function (state) {
        state.savingInstances++;
    },
    DEC_SAVINGINSTANCES: function (state) {
        if (state.savingInstances > 0)
            state.savingInstances--;
    },
    RESET_SAVINGINSTANCES: function (state) {
        state.savingInstances = 0;
    },
    SET_SAVEFAILED: function (state, value) {
        state.saveFailed = value;
    },
    SET_SAVED: function (state, value) {
        state.saved = value;
    },
    SET_LOADING: function (state, value) {
        state.loading = value;
    },
    SET_DOWNLOADING_PDF: function (state, value) {
        state.downloadingPdf = value;
    },
    SET_DOWNLOADING_FILE: function (state, value) {
        state.downloadingFile = value;
    },
    SET_SECTION: function (state, value) {
        state.section = value;
    },
    SET_PERIOD: function (state, value) {
        state.period = value;
    },
    SET_MONTH: function (state, value) {
        state.month = value;
    },
    SET_LOCKING: function (state, value) {
        state.locking = value;
    },
    SET_SECTION_LOCK_STATUS: function (state, value) {
        state.sectionLockStatus = value;
    },
    SET_RECORDID: function (state, value) {
        state.recordId = value;
    },
    SET_RECORDABLE: function (state, value) {
        state.recordable = value;
    },
    SET_RESET: function (state, value) {
        state.reset = value;
    },
    SET_ACTIVE_MENUTAB: function (state, value) {
        state.activeMenuTab = value;
    },
    SET_LOCK: function (state, value) {
        state.lock = value;
    },
    SET_DIRTY: function (state, value) {
        state.dirty = value;
    },
    SET_MODIFIED: function (state, value) {
        if (value) {
            state.dirty = true;
        }
        state.modified = value;
    },
    SET_VALIDATIONERRORS: function (state, value) {
        state.validationErrors = value;
    },
    SET_CONFIGURATION: function (state, value) {
        state.configuration = value;
    },
    SET_MUNICIPALITIES: function (state, payload) {
        var code = payload.lang;
        state.municipalities[code] = payload.municipalities;
    },
    SET_REGIONS: function (state, payload) {
        var code = payload.lang;
        state.regions[code] = payload.regions;
    },
    SET_WELLBEINGSERVICECOUNTIES: function (state, payload) {
        var code = payload.lang;
        state.wellbeingServiceCounties[code] = payload.counties;
    },
    SET_CONGREGATIONS: function (state, payload) {
        var code = payload.lang;
        state.congregations[code] = payload.congregations;
    },
    SET_ORGANISATIONS: function (state, payload) {
        state.organisations = payload.organisations;
    },
    SET_APPLICATIONTYPES: function (state, payload) {
        state.applicationTypes = payload.applicationTypes;
    },
    SET_SHOW_EXTENSION_APPLY: function (state, value) {
        state.showExtensionApply = value;
    },
    SET_FLAG: function (state, payload) {
        state.apiFlags[payload] = true;
    },
    UNSET_FLAG: function (state, payload) {
        state.apiFlags[payload] = false;
    },
    SET_CORRESPONDENCES_COUNT: function (state, value) {
        state.correspondencesCount = value;
    },
    SET_PREVENTSENDING: function (state, payload) {
        state.preventSending = payload.value;
        state.preventSendingMessage = payload.message;
    },
    SET_CUSTOMREADONLY: function (state, value) {
        state.customReadOnly = value;
    },
    SET_CURRENTMODEL: function (state, value) {
        state.currentModel = value;
    },
    SET_USERS: function (state, value) {
        state.users = value;
    },
    SET_COOKIEPOLICY: function (state, value) {
        state.cookiePolicy = value;
        state.isConsented = value.isConsented();
    }
};
var actions = {
    setLanguage: function (_a, language) {
        var commit = _a.commit;
        commit("SET_LANGUAGE", language);
    },
    setTimeout: function (_a, interval) {
        var commit = _a.commit;
        commit("SET_TIMEOUT", interval);
    },
    clearTimeout: function (_a) {
        var commit = _a.commit;
        commit("CLEAR_TIMEOUT");
    },
    startSaving: function (_a) {
        var commit = _a.commit;
        commit("SET_SAVING", true);
    },
    stopSaving: function (_a) {
        var commit = _a.commit;
        commit("SET_SAVING", false);
    },
    setSaved: function (_a) {
        var commit = _a.commit;
        commit("SET_SAVED", true);
        commit("SET_SAVEFAILED", false);
    },
    setSaveFailed: function (_a) {
        var commit = _a.commit;
        commit("SET_SAVEFAILED", true);
    },
    clearSaveFailed: function (_a) {
        var commit = _a.commit;
        commit("SET_SAVEFAILED", false);
    },
    triggerReset: function (_a) {
        var commit = _a.commit;
        commit("SET_RESET", true);
    },
    primeResetTrigger: function (_a) {
        var commit = _a.commit;
        commit("SET_RESET", false);
    },
    setSection: function (_a, section) {
        var commit = _a.commit;
        commit("SET_SECTION", section);
    },
    setPeriod: function (_a, period) {
        var commit = _a.commit;
        commit("SET_PERIOD", period);
    },
    setMonth: function (_a, month) {
        var commit = _a.commit;
        commit("SET_MONTH", month);
    },
    setRecordId: function (_a, id) {
        var commit = _a.commit;
        commit("SET_RECORDID", id);
    },
    setPreventSending: function (_a, message) {
        var commit = _a.commit;
        commit('SET_PREVENTSENDING', { value: true, message: message });
    },
    clearPreventSending: function (_a) {
        var commit = _a.commit;
        commit('SET_PREVENTSENDING', { value: false, message: null });
    },
    initMunicipalities: function (_a) {
        var commit = _a.commit, getters = _a.getters, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var masterDataService, languageCodes, languageCodes_1, languageCodes_1_1, lang, municipalities, language, e_1_1;
            var e_1, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!!getters.flag('municipalities')) return [3 /*break*/, 11];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, , 10, 11]);
                        commit('SET_FLAG', 'municipalities');
                        masterDataService = new MasterDataService();
                        languageCodes = Object.keys(state.municipalities);
                        _c.label = 2;
                    case 2:
                        _c.trys.push([2, 7, 8, 9]);
                        languageCodes_1 = __values(languageCodes), languageCodes_1_1 = languageCodes_1.next();
                        _c.label = 3;
                    case 3:
                        if (!!languageCodes_1_1.done) return [3 /*break*/, 6];
                        lang = languageCodes_1_1.value;
                        municipalities = state.municipalities[lang];
                        if (!ValidationUtilities.isEmptyArray(municipalities)) return [3 /*break*/, 5];
                        language = convertToLanguage(lang);
                        return [4 /*yield*/, masterDataService.getMunicipalities(language)];
                    case 4:
                        municipalities = _c.sent();
                        commit("SET_MUNICIPALITIES", { lang: lang, municipalities: municipalities });
                        _c.label = 5;
                    case 5:
                        languageCodes_1_1 = languageCodes_1.next();
                        return [3 /*break*/, 3];
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        e_1_1 = _c.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 9];
                    case 8:
                        try {
                            if (languageCodes_1_1 && !languageCodes_1_1.done && (_b = languageCodes_1.return)) _b.call(languageCodes_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        commit('UNSET_FLAG', 'municipalities');
                        return [7 /*endfinally*/];
                    case 11: return [2 /*return*/];
                }
            });
        });
    },
    initRegions: function (_a) {
        var commit = _a.commit, getters = _a.getters, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var masterDataService, languageCodes, languageCodes_2, languageCodes_2_1, lang, regions, language, e_2_1;
            var e_2, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!!getters.flag('regions')) return [3 /*break*/, 11];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, , 10, 11]);
                        commit('SET_FLAG', 'regions');
                        masterDataService = new MasterDataService();
                        languageCodes = Object.keys(state.regions);
                        _c.label = 2;
                    case 2:
                        _c.trys.push([2, 7, 8, 9]);
                        languageCodes_2 = __values(languageCodes), languageCodes_2_1 = languageCodes_2.next();
                        _c.label = 3;
                    case 3:
                        if (!!languageCodes_2_1.done) return [3 /*break*/, 6];
                        lang = languageCodes_2_1.value;
                        regions = state.regions[lang];
                        if (!ValidationUtilities.isEmptyArray(regions)) return [3 /*break*/, 5];
                        language = convertToLanguage(lang);
                        return [4 /*yield*/, masterDataService.getRegions(language)];
                    case 4:
                        regions = _c.sent();
                        commit("SET_REGIONS", { lang: lang, regions: regions });
                        _c.label = 5;
                    case 5:
                        languageCodes_2_1 = languageCodes_2.next();
                        return [3 /*break*/, 3];
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        e_2_1 = _c.sent();
                        e_2 = { error: e_2_1 };
                        return [3 /*break*/, 9];
                    case 8:
                        try {
                            if (languageCodes_2_1 && !languageCodes_2_1.done && (_b = languageCodes_2.return)) _b.call(languageCodes_2);
                        }
                        finally { if (e_2) throw e_2.error; }
                        return [7 /*endfinally*/];
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        commit('UNSET_FLAG', 'regions');
                        return [7 /*endfinally*/];
                    case 11: return [2 /*return*/];
                }
            });
        });
    },
    initWellbeingServiceCounties: function (_a) {
        var commit = _a.commit, getters = _a.getters, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var masterDataService, languageCodes, languageCodes_3, languageCodes_3_1, lang, counties, language, e_3_1;
            var e_3, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!!getters.flag('wellbeingServiceCounties')) return [3 /*break*/, 11];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, , 10, 11]);
                        commit('SET_FLAG', 'wellbeingServiceCounties');
                        masterDataService = new MasterDataService();
                        languageCodes = Object.keys(state.wellbeingServiceCounties);
                        _c.label = 2;
                    case 2:
                        _c.trys.push([2, 7, 8, 9]);
                        languageCodes_3 = __values(languageCodes), languageCodes_3_1 = languageCodes_3.next();
                        _c.label = 3;
                    case 3:
                        if (!!languageCodes_3_1.done) return [3 /*break*/, 6];
                        lang = languageCodes_3_1.value;
                        counties = state.wellbeingServiceCounties[lang];
                        if (!ValidationUtilities.isEmptyArray(counties)) return [3 /*break*/, 5];
                        language = convertToLanguage(lang);
                        return [4 /*yield*/, masterDataService.getWellbeingServiceCounties(language)];
                    case 4:
                        counties = _c.sent();
                        commit("SET_WELLBEINGSERVICECOUNTIES", { lang: lang, counties: counties });
                        _c.label = 5;
                    case 5:
                        languageCodes_3_1 = languageCodes_3.next();
                        return [3 /*break*/, 3];
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        e_3_1 = _c.sent();
                        e_3 = { error: e_3_1 };
                        return [3 /*break*/, 9];
                    case 8:
                        try {
                            if (languageCodes_3_1 && !languageCodes_3_1.done && (_b = languageCodes_3.return)) _b.call(languageCodes_3);
                        }
                        finally { if (e_3) throw e_3.error; }
                        return [7 /*endfinally*/];
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        commit('UNSET_FLAG', 'wellbeingServiceCounties');
                        return [7 /*endfinally*/];
                    case 11: return [2 /*return*/];
                }
            });
        });
    },
    initCongregations: function (_a) {
        var commit = _a.commit, getters = _a.getters, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var masterDataService, languageCodes, languageCodes_4, languageCodes_4_1, lang, congregations, language, e_4_1;
            var e_4, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!!getters.flag('congregations')) return [3 /*break*/, 11];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, , 10, 11]);
                        commit('SET_FLAG', 'congregations');
                        masterDataService = new MasterDataService();
                        languageCodes = Object.keys(state.congregations);
                        _c.label = 2;
                    case 2:
                        _c.trys.push([2, 7, 8, 9]);
                        languageCodes_4 = __values(languageCodes), languageCodes_4_1 = languageCodes_4.next();
                        _c.label = 3;
                    case 3:
                        if (!!languageCodes_4_1.done) return [3 /*break*/, 6];
                        lang = languageCodes_4_1.value;
                        congregations = state.congregations[lang];
                        if (!ValidationUtilities.isEmptyArray(congregations)) return [3 /*break*/, 5];
                        language = convertToLanguage(lang);
                        return [4 /*yield*/, masterDataService.getCongregations(language)];
                    case 4:
                        congregations = _c.sent();
                        commit("SET_CONGREGATIONS", { lang: lang, congregations: congregations });
                        _c.label = 5;
                    case 5:
                        languageCodes_4_1 = languageCodes_4.next();
                        return [3 /*break*/, 3];
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        e_4_1 = _c.sent();
                        e_4 = { error: e_4_1 };
                        return [3 /*break*/, 9];
                    case 8:
                        try {
                            if (languageCodes_4_1 && !languageCodes_4_1.done && (_b = languageCodes_4.return)) _b.call(languageCodes_4);
                        }
                        finally { if (e_4) throw e_4.error; }
                        return [7 /*endfinally*/];
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        commit('UNSET_FLAG', 'congregations');
                        return [7 /*endfinally*/];
                    case 11: return [2 /*return*/];
                }
            });
        });
    },
    initOrganisations: function (_a, recordId) {
        var commit = _a.commit, getters = _a.getters, state = _a.state;
        if (recordId === void 0) { recordId = undefined; }
        return __awaiter(this, void 0, void 0, function () {
            var masterDataService, organisations;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!getters.flag('organisations')) return [3 /*break*/, 5];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 4, 5]);
                        commit('SET_FLAG', 'organisations');
                        masterDataService = new MasterDataService();
                        organisations = state.organisations;
                        if (!ValidationUtilities.isEmptyArray(organisations)) return [3 /*break*/, 3];
                        if (recordId === undefined || recordId === null) {
                            recordId = state.recordId;
                        }
                        return [4 /*yield*/, masterDataService.getOrganisationOptions(recordId)];
                    case 2:
                        organisations = _b.sent();
                        commit("SET_ORGANISATIONS", { organisations: organisations });
                        _b.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        commit('UNSET_FLAG', 'organisations');
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    },
    initAidApplicationSettings: function (_a) {
        var commit = _a.commit, getters = _a.getters, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var masterDataService, applicationTypes, applicationSettings;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!getters.flag('applicationtypes')) return [3 /*break*/, 5];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 4, 5]);
                        commit('SET_FLAG', 'applicationtypes');
                        masterDataService = new MasterDataService();
                        applicationTypes = state.applicationTypes;
                        if (!ValidationUtilities.isEmptyArray(applicationTypes)) return [3 /*break*/, 3];
                        return [4 /*yield*/, masterDataService.getAidApplicationSettings()];
                    case 2:
                        applicationSettings = _b.sent();
                        if (applicationSettings) {
                            applicationTypes = applicationSettings.aidTypes;
                            commit("SET_APPLICATIONTYPES", { applicationTypes: applicationTypes });
                            commit("SET_SHOW_EXTENSION_APPLY", applicationSettings.showExtensionApply);
                        }
                        _b.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        commit('UNSET_FLAG', 'applicationtypes');
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    },
    clearSectionValidationErrors: function (_a, payload) {
        var commit = _a.commit, state = _a.state;
        var sectionNumber = Number(payload);
        var remainingErrors = state.validationErrors.filter(function (error) { return error.groupId != sectionNumber; });
        commit('SET_VALIDATIONERRORS', remainingErrors);
    },
    clearPeriodValidationErrors: function (_a, payload) {
        var commit = _a.commit, state = _a.state;
        var sectionNumber = Number(payload.section);
        var periodId = Number(payload.period);
        var remainingErrors = state.validationErrors.filter(function (error) { return !(error.periodId == periodId && error.groupId == sectionNumber); });
        commit('SET_VALIDATIONERRORS', remainingErrors);
    },
    clearMonthValidationErrors: function (_a, payload) {
        var commit = _a.commit, state = _a.state;
        var sectionNumber = Number(payload.section);
        var periodId = Number(payload.period);
        var monthId = Number(payload.month);
        var remainingErrors = state.validationErrors.filter(function (error) { return !(error.monthId == monthId && error.periodId == periodId && error.groupId == sectionNumber); });
        commit('SET_VALIDATIONERRORS', remainingErrors);
    },
    clean: function (_a) {
        var dispatch = _a.dispatch, commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, dispatch('cleanSectionState')];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, dispatch('cleanRecordState')];
                    case 2:
                        _b.sent();
                        return [4 /*yield*/, dispatch('clearPreventSending')];
                    case 3:
                        _b.sent();
                        commit('SET_CUSTOMREADONLY', false);
                        return [2 /*return*/];
                }
            });
        });
    },
    cleanSectionState: function (_a) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                // Reset section ready flags
                commit('UNSET_FLAG', 'lockChecked');
                commit('UNSET_FLAG', 'dataRetrieved');
                commit('UNSET_FLAG', 'validationDone');
                // Reset state flags
                commit('SET_LOCK', false);
                commit('SET_LOCKING', false);
                commit('SET_DIRTY', false);
                commit('SET_MODIFIED', false);
                //async resetSaveState()
                commit('SET_SAVING', false);
                commit('RESET_SAVINGINSTANCES');
                commit('SET_SAVED', false);
                commit('SET_SAVEFAILED', false);
                return [2 /*return*/];
            });
        });
    },
    cleanRecordState: function (_a) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                commit('SET_RECORDABLE', null);
                commit('SET_VALIDATIONERRORS', []);
                commit('SET_RECORDID', null);
                commit('SET_SECTION', 0);
                commit('SET_PERIOD', 0);
                commit('SET_MONTH', 0);
                commit('SET_SECTION_LOCK_STATUS', {});
                return [2 /*return*/];
            });
        });
    },
    countOpenCorrespondences: function (_a) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var entityService, count;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        entityService = new EntityService();
                        return [4 /*yield*/, entityService.getCorrespondencesCount()];
                    case 1:
                        count = _b.sent();
                        commit('SET_CORRESPONDENCES_COUNT', count);
                        return [2 /*return*/];
                }
            });
        });
    },
    /**
     * Releases all held locks and cleans the application state.
     **/
    reset: function (_a) {
        var dispatch = _a.dispatch, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var recordId, sectionNumber, appId, entityService;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        recordId = state.recordId;
                        sectionNumber = state.section;
                        appId = state.appId;
                        if (!(recordId && sectionNumber && appId)) return [3 /*break*/, 2];
                        entityService = new EntityService();
                        return [4 /*yield*/, entityService.clearSectionLock(recordId, sectionNumber, appId)];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [4 /*yield*/, dispatch('clean')];
                    case 3:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
};
var namespaced = true;
export var vuexPageModule = {
    namespaced: namespaced,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};
